<template>
  <div>
    <v-dialog v-model="is_generate_invoice" max-width="1300" persistent>
      <v-card :loading="loading">
        <v-card-title class="headline">Invoice</v-card-title>
        <v-card-text class>
          <v-data-table
            class="elevation-1 mt-1 rounded-0 my-transaction-table"
            :items="items"
            hide-default-footer
            mobile-breakpoint="50"
            disable-pagination
            dense
            fixed-header
            style="max-height:500px;overflow-y:auto;"
          >
            <template v-slot:body.prepend>
              <tr class="header-background white-border right-border-white">
                <td width="5%" class="text-center">A</td>
                <td width="32%" class="text-left">B</td>
                <td width="10%" class="text-right pr-9">C</td>
                <td width="10%" class="text-right pr-8">D</td>
                <td width="10%" class="text-right pr-10">E</td>
                <td width="10%" class="text-right pr-10">F</td>
                <td width="15%" class="text-center pl-10" colspan="2">G</td>
                <td width="10%" class="text-right pr-5">H</td>
                <td width="8%" class="text-right pr-8">I</td>
                <!-- <td
                  width="10%"
                  class="text-right pr-10"
                >J</td>-->
              </tr>
              <tr class="header-background right-border-white">
                <td width="5%" class="text-center">
                  Item
                  <br />No.
                </td>
                <td width="27%" class="text-left">Description of work</td>
                <td width="10%" class="text-right">
                  Scheduled
                  <br />Value
                </td>
                <td width="11%" class="text-right">
                  Previous
                  <br />(D+E)
                </td>
                <td width="16%" class="text-center">This Period</td>
                <td width="7%" class="text-center">Materials presently stored</td>
                <td width="11%" class="text-right">
                  Total
                  <br />Completed
                  <br />(D+E+F)
                </td>
                <td width="5%" class="text-right">
                  %
                  <br />(G/C)
                </td>
                <td width="10%" class="text-right">
                  Balance
                  <br />(C-G)
                </td>
                <td width="8%" class="text-right">Retainage</td>
              </tr>
            </template>
            <template v-slot:item="{ item, index}">
              <tr
                class="right-border-grey"
                :style="item.rowWithColor ==true ? 'background-color:#ffebee': ''"
              >
                <td width="5%" style="text-align:center;">{{index+1}}</td>
                <td width="27%" style="text-align:left;">{{item.group_name}}</td>
                <td width="10%" style="text-align:right;">${{item.total_group_amount.toFixed(2)}}</td>
                <td
                  width="11%"
                  style="text-align:right;"
                  :class="item.previous_amount < 0 ? 'error--text' : '' "
                >{{item.previous_amount ? '$'+parseFloat(getAmountFormat(item.previous_amount)).toFixed(2): ''}}</td>

                <!-- <td width="16%" style="text-align:right;" :class="(item.total_group_amount) < (parseFloat(item.current_amount) + parseFloat(item.previous_amount)) ? 'error--text' : ''">
                  ${{item.current_amount ? item.current_amount.toFixed(2) : 0}} <v-icon @click="changeTranAmtDialog(item)">mdi-border-color</v-icon>
                </td>-->
                <td
                  width="16%"
                  style="text-align:right;"
                  :class="item.current_amount < 0 ? 'error--text' : item.current_amount == 0  ?  ''  :  'primary--text' "
                >
                  ${{item.display_current_amount ? item.display_current_amount : 0}}
                  <v-icon @click="changeTranAmtDialog(item)">mdi-border-color</v-icon>
                </td>
                <td width="7%" style="text-align:right;"></td>
                <td
                  width="11%"
                  style="text-align:right;"
                >{{item.display_completed_amount ? '$'+item.display_completed_amount : ''}}</td>
                <td
                  width="5%"
                  style="text-align:right;"
                >{{(item.display_percent_value != 0 ? item.display_percent_value+' %' : '')}}</td>
                <td
                  width="10%"
                  style="text-align:right;"
                  :class="item.balance_amount < 0 ? 'error--text' : '' "
                >${{(getAmountFormat(item.balance_amount))}}</td>
                <td
                  width="8%"
                  style="text-align:right;"
                >{{ (item.display_retainage_amount != 0)? item.display_retainage_amount : ''}}</td>
              </tr>
            </template>

            <template v-slot:body.append>
              <tr class="grey-lighten-background right-border-grey">
                <td width="5%"></td>
                <td width="27%" style="text-align:left;">Total</td>
                <td width="10%" style="text-align:right;">${{parseFloat(total_amt).toFixed(2)}}</td>
                <td
                  width="11%"
                  style="text-align:right;"
                  :class="total_previous_amount < 0 ? 'error--text' : '' "
                >${{getAmountFormat(total_previous_amount)}}</td>
                <td width="16%" style="text-align:right;">
                  <span
                    style="margin-right:25px"
                    :class="total_current_amount < 0 ? 'error--text' : '' "
                  >${{getAmountFormat(total_current_amount)}}</span>
                </td>
                <td width="7%" style="text-align:right;"></td>
                <td
                  width="11%"
                  style="text-align:right;"
                >${{getAmountFormat(total_completed_amount)}}</td>
                <td width="10%"></td>
                <td
                  width="10%"
                  style="text-align:right;"
                  :class="total_balance_amount < 0 ? 'error--text' : ''"
                >${{getAmountFormat(total_balance_amount)}}</td>
                <td
                  width="8%"
                  style="text-align:right;"
                >{{total_retainage_amount !=0 ? total_retainage_amount : ''}}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="$emit('closeDialog')" :disabled="loading">Cancel</v-btn>
          <v-spacer></v-spacer>

          <v-btn
            :loading="loading"
            color="primary"
            class="pr-3 text-capitalize"
            @click="generateInvoice()"
            :disabled="generate_btn_flag"
          >{{is_update_invoice ? 'Update Invoice' : 'Save Invoice' }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="change_tran_amt_dialog" max-width="1200" persistent>
      <v-card :loading="generate_invoice_loading">
        <v-card-title class="headline">Update Invoice Amount</v-card-title>
        <v-card-text class>
          <v-simple-table dense>
            <thead style="background: #455a64;">
              <tr class="grey-lighten-background right-border-grey">
                <td width="40%">
                  <b>{{this.selected_group.group_name}}</b>
                </td>
                <td width="20%"></td>
                <td>Scheduled :</td>
                <td>${{parseFloat(this.selected_group.total_group_amount).toFixed(2)}}</td>
                <td style="text-align:right">Previous :</td>
                <td>${{parseFloat(this.selected_group.previous_amount).toFixed(2)}}</td>
              </tr>
            </thead>
          </v-simple-table>
          <v-simple-table dense class="mt-5">
            <thead style="background: #455a64;">
              <tr>
                <td width="10%" class="white--text">Bank</td>
                <td width="10%" class="white--text">Date</td>
                <td width="12%" class="white--text text-right">Amount</td>
                <td width="12%" class="white--text">Vendor</td>
                <td width="16%" class="white--text">INV Amt</td>
                <td width="40%" class="white--text">Description</td>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(row, index) in trans_items"
                :key="index"
                class="mt-3"
                :style="row.rowWithColor ==true ? 'background-color:#ffebee': ''"
              >
                <td>{{row.bank_id ? row.bank.bank_code : '' }}</td>
                <td>{{ getFormatedDate(row.trans_date) }}</td>
                <td class="text-right">
                  <div>
                    <span
                      :class="{
                        'error--text': row.rev_amount < 0,
                        'primary--text': row.rev_amount > 0,
                      }"
                    >${{ getAmountFormat(row.rev_amount) }}</span>
                  </div>
                </td>
                <td>
                  <v-tooltip bottom v-if="row.expence">
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-bind="attrs"
                        v-on="on"
                      >{{ (row.expance_details)?row.expance_details.bank_code:'' }}</span>
                    </template>
                    <span>{{ (row.expance_details)?row.expance_details.bank_name:'' }}</span>
                  </v-tooltip>
                  <v-tooltip bottom v-else>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">{{ (row.vendor)?row.vendor.v_code:'' }}</span>
                    </template>
                    <span>{{ (row.vendor)?row.vendor.v_name:'' }}</span>
                  </v-tooltip>
                </td>
                <td
                  :class="{  'error--text': row.inv_amt < 0,  'primary--text': row.inv_amt > 0, }"
                >
                  <v-text-field
                    style="margin-top: -2px;"
                    v-model="row.display_inv_amt"
                    type="number"
                    dense
                    hide-details
                    :class="{
                        'error--text': row.inv_amt < 0,
                        'primary--text': row.inv_amt > 0,
                      }"
                    @input="getTotalUpdatevalue()"
                  ></v-text-field>
                </td>
                <td>
                  <div>
                    <v-tooltip left max-width="400">
                      <template v-slot:activator="{ on, attrs }">
                        <span
                          v-bind="attrs"
                          v-on="on"
                          class="d-inline-block"
                          style="word-break: break-all;"
                          v-html="row.description.substring(0,40)"
                        >
                          <span v-if="row.description.length > 40">..</span>
                        </span>
                      </template>
                      <span>{{ row.description }}</span>
                    </v-tooltip>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="4">Company Expense</td>
                <td>
                  <v-text-field
                    style="margin-top: -2px;"
                    type="number"
                    v-model="extra_amount"
                    dense
                    hide-details
                    class="error--text"
                    @input="getTotalUpdatevalue()"
                  ></v-text-field>
                </td>
                <td colspan="2"></td>
              </tr>
              <tr class="grey-lighten-background right-border-grey">
                <td></td>
                <td></td>
                <td class="text-right">${{getTransacionVal()}}</td>
                <td></td>
                <td
                  :class="updated_amt_total< 0 ? 'error--text' : 'primary--text'"
                >${{parseFloat(this.display_updated_amt_total).toFixed(2)}}</td>
                <td>
                  Balance :
                  <span
                    :class="this.last_match_balance_value<0 ? 'error--text' :''"
                  >${{parseFloat(getAmountFormat(this.last_match_balance_value)).toFixed(2)}}</span>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="error"
            @click="change_tran_amt_dialog = false"
            :disabled="generate_invoice_loading"
          >Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            :loading="generate_invoice_loading"
            color="primary"
            class="pr-3 text-capitalize"
            @click="updateInvoiceAmt()"
            :disabled="invoice_btn_flag"
          >Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "../../plugins/axios";
import moment from "moment";
import { mapMutations } from "vuex";
import { getTotalOrderAmountwithAllcalculation } from "../../plugins/helper";
export default {
  data() {
    return {
      loading: false,
      generate_invoice_loading: false,
      items: [],
      trans_items: [],
      selected_group: {},
      total_amt: 0,
      total_previous_amount: "",
      change_tran_amt_dialog: false,
      updated_amt_total: 0,
      display_updated_amt_total: 0,
      invoice_btn_flag: false,
      generate_btn_flag: false,
      last_match_balance_value: "",
      extra_amount: "",
      has_extra_row: 0
    };
  },
  props: [
    "is_generate_invoice",
    "project_details",
    "selected_rows",
    "is_update_invoice",
    "generate_invoice_id"
  ],
  watch: {
    is_generate_invoice: function(value) {
      this.items = [];
      if (value) {
        let preserveGroupData = [];
        console.log(this.selected_rows);
        this.selected_rows = this.selected_rows.filter(item => {
          if (item.invoice_amt) {
            console.log(item.invoice_amt, "item.invoice_amt");
            item.inv_amt = parseFloat(item.invoice_amt).toFixed(2);
            item.display_inv_amt = parseFloat(
              this.getAmountFormat(item.invoice_amt)
            ).toFixed(2);
            const compareAmt = this.getInvoiceAmt(item);
            const compareDisplayAmount = parseFloat(
              this.getAmountFormat(compareAmt)
            ).toFixed(2);

            if (item.display_inv_amt != compareDisplayAmount) {
              item.rowWithColor = true;
              preserveGroupData.push({
                group_id: item.invoice_group_id,
                change_order: item.change_order
              });
            }
          } else {
            item.inv_amt = this.getInvoiceAmt(item);
            item.display_inv_amt = parseFloat(
              this.getAmountFormat(item.inv_amt)
            ).toFixed(2);
          }
          return item;
        });

        let project_data_flag = "";
        if (this.project_details.project_work.length > 0) {
          if (this.project_details.project_work == "remodeling") {
            project_data_flag = 2;
          } else if (this.project_details.project_work == "new_construction") {
            project_data_flag = 1;
          } else if (
            this.project_details.project_work == "project_management"
          ) {
            project_data_flag = 4;
          }
        }
        this.loading = true;
        axios
          .get(
            "get_item_group?project_id=" +
              this.project_details.project_id +
              "&project_data_flag=" +
              project_data_flag +
              "&is_update_invoice=" +
              this.is_update_invoice +
              "&generate_invoice_id=" +
              this.generate_invoice_id +
              "&is_from=transaction"
          )
          .then(response => {
            let response_data = response.data;
            this.items = response_data.data;
            this.total_amt = response_data.total_amt;
            let total_previous_amount = 0;
            let $i = 0;
            let preservedData = [];

            this.items.filter(item2 => {
              let current_amount = 0;
              current_amount = item2.is_extra_amount
                ? parseFloat(item2.total_extra_amount)
                : 0;
              this.selected_rows.filter(item3 => {
                if (
                  item3.invoice_group_id == item2.invoice_group_id &&
                  item3.change_order == item2.change_order
                ) {
                  current_amount += parseFloat(item3.inv_amt);
                }

                item2.current_amount = current_amount;
                item2.display_current_amount = parseFloat(
                  this.getAmountFormat(current_amount)
                ).toFixed(2);
                item2.completed_amount = this.getCompletedAmount(item2);
                item2.display_completed_amount = parseFloat(
                  this.getAmountFormat(item2.completed_amount)
                ).toFixed(2);
                item2.balance_amount = parseFloat(
                  this.getBalanceAmount(item2)
                ).toFixed(2);
                item2.percent_value = this.getPercentAmount(item2);
                item2.display_percent_value = this.getAmountFormat(
                  this.getPercentAmount(item2)
                );
                item2.retainage_amount = this.getRetainageAmount(item2);
                item2.display_retainage_amount = this.getAmountFormat(
                  this.getRetainageAmount(item2)
                );
                if (item2.balance_amount >= 0 && item2.balance_amount <= 0.09) {
                  item2.balance_amount = parseFloat(0).toFixed(2);
                }
              });
              // Check if invoice_group_id and change_order match any item in preserveGroupData
              if (item2.balance_amount < 0) {
                // $i++;
                item2.rowWithColor = true;
                preservedData.push({
                  group_id: item2.invoice_group_id,
                  change_order: item2.change_order,
                  amount: item2.previous_amount + item2.total_group_amount,
                  balance_amount: item2.balance_amount
                });
              }
              preserveGroupData.forEach(preserveItem => {
                if (
                  item2.invoice_group_id === preserveItem.group_id &&
                  item2.change_order === preserveItem.change_order
                ) {
                  item2.rowWithColor = true; // Set the rowWithColor property to true if there’s a match
                }
              });
              // total_previous_amount += item2.previous_amount
              //   ? parseFloat(item2.previous_amount)
              //   : 0;
            });

            preservedData.forEach(preservedItem => {
              console.log("1111");
              const amountToAdjust = parseFloat(preservedItem.amount);
              const matchingRows = this.selected_rows.filter(
                row =>
                  row.invoice_group_id === preservedItem.group_id &&
                  row.change_order === preservedItem.change_order
              );

              const removeIds = [];

              if (amountToAdjust === 0) {
                // Remove all matching rows, set selected to false
                matchingRows.forEach(row => {
                  row.selected = false;
                  removeIds.push(row.trans_id);
                });
              } else {
                const sortedRows = [...matchingRows].sort(
                  (a, b) =>
                    parseFloat(b.display_inv_amt) -
                    parseFloat(a.display_inv_amt)
                );

                let accumulated = 0;
                let usedRows = [];

                for (let i = 0; i < sortedRows.length; i++) {
                  accumulated = 0;
                  usedRows = [];

                  for (let j = 0; j <= i; j++) {
                    const row = sortedRows[j];
                    const displayAmt = parseFloat(row.display_inv_amt);
                    const remaining = amountToAdjust - accumulated;

                    if (remaining <= 0) break;

                    if (displayAmt >= remaining) {
                      // Final row: adjust only needed amount
                      const invSign = parseFloat(row.inv_amt) < 0 ? -1 : 1;
                      const newInvAmt = invSign * remaining;

                      row.inv_amt = newInvAmt.toFixed(2);
                      row.display_inv_amt = Math.abs(newInvAmt).toFixed(2);
                      row.rowWithColor = true; // Adjusted row is marked with color
                      row.selected = true;
                      usedRows.push(row.trans_id);
                      accumulated += remaining;
                      break;
                    } else {
                      // Use entire row
                      row.rowWithColor = false; // Mark the row that is used for adjustment
                      row.selected = true;
                      usedRows.push(row.trans_id);
                      accumulated += displayAmt;
                    }
                  }

                  if (accumulated >= amountToAdjust) break;
                }

                // Remove all unused rows and set selected to false
                matchingRows.forEach(row => {
                  if (!usedRows.includes(row.trans_id)) {
                    row.selected = false;
                    row.rowWithColor = false; // Ensure unused rows are not marked with color
                    removeIds.push(row.trans_id);
                  }
                });
              }

              // Final cleanup: remove rows that were not used and set their selected to false
              this.selected_rows = this.selected_rows.filter(
                row => !removeIds.includes(row.trans_id)
              );
            });

            this.items.filter(item2 => {
              let current_amount = 0;
              current_amount = item2.is_extra_amount
                ? parseFloat(item2.total_extra_amount)
                : 0;
              // set all value for without transaction
              item2.current_amount = current_amount;

              item2.display_current_amount = parseFloat(
                this.getAmountFormat(current_amount)
              ).toFixed(2);

              item2.completed_amount = this.getCompletedAmount(item2);

              item2.display_completed_amount = parseFloat(
                this.getAmountFormat(item2.completed_amount)
              ).toFixed(2);
              item2.balance_amount = parseFloat(
                this.getBalanceAmount(item2)
              ).toFixed(2);
              item2.percent_value = this.getPercentAmount(item2);
              item2.display_percent_value = this.getAmountFormat(
                this.getPercentAmount(item2)
              );
              item2.retainage_amount = this.getRetainageAmount(item2);
              item2.display_retainage_amount = this.getAmountFormat(
                this.getRetainageAmount(item2)
              );

              // set value for selected  transaction
              this.selected_rows.filter(item3 => {
                if (
                  item3.invoice_group_id == item2.invoice_group_id &&
                  item3.change_order == item2.change_order
                ) {
                  current_amount += parseFloat(item3.inv_amt);
                }
                item2.current_amount = current_amount;
                item2.display_current_amount = parseFloat(
                  this.getAmountFormat(current_amount)
                ).toFixed(2);

                item2.completed_amount = this.getCompletedAmount(item2);
                item2.display_completed_amount = parseFloat(
                  this.getAmountFormat(item2.completed_amount)
                ).toFixed(2);
                item2.balance_amount = parseFloat(
                  this.getBalanceAmount(item2)
                ).toFixed(2);
                item2.percent_value = this.getPercentAmount(item2);
                item2.display_percent_value = this.getAmountFormat(
                  this.getPercentAmount(item2)
                );
                item2.retainage_amount = this.getRetainageAmount(item2);
                item2.display_retainage_amount = this.getAmountFormat(
                  this.getRetainageAmount(item2)
                );
                if (item2.balance_amount >= 0 && item2.balance_amount <= 0.09) {
                  item2.balance_amount = parseFloat(0).toFixed(2);
                }

                if (item2.balance_amount < 0) {
                  $i++;
                }
              });
              total_previous_amount += item2.previous_amount
                ? parseFloat(item2.previous_amount)
                : 0;
            });

            if ($i > 0) {
              this.generate_btn_flag = true;
            } else {
              this.generate_btn_flag = false;
            }

            this.total_previous_amount = parseFloat(
              total_previous_amount
            ).toFixed(2);
            this.loading = false;
          })
          .catch(function(error) {
            console.log(error);
            this.loading = false;
          });
      }
    }
  },
  computed: {
    total_current_amount() {
      let total = 0;
      this.items.filter(item => {
        total += item.current_amount;
      });
      return parseFloat(total).toFixed(2);
    },
    total_completed_amount() {
      let total = 0;
      this.items.filter(item => {
        total += this.getCompletedAmount(item);
      });
      return parseFloat(total).toFixed(2);
    },
    total_balance_amount() {
      let total = 0;
      this.items.filter(item => {
        total += this.getBalanceAmount(item);
      });
      return parseFloat(total).toFixed(2);
    },
    total_retainage_amount() {
      let total = 0;
      this.items.filter(item => {
        let ret = this.getRetainageAmount(item);
        total += ret ? ret : 0;
      });

      return parseFloat(total).toFixed(2);
    }
  },
  methods: {
    ...mapMutations("utils", ["setAlert"]),
    getTransacionVal() {
      var total = 0;
      this.trans_items.filter(item2 => {
        total += item2.rev_amount ? parseFloat(item2.rev_amount) : 0;
      });
      total = this.getAmountFormat(total);

      return parseFloat(total).toFixed(2);
    },
    getTotalUpdatevalue() {
      var total = 0;
      this.trans_items.filter(item2 => {
        if (item2.display_inv_amt == this.getAmountFormat(item2.inv_amt)) {
          total += parseFloat(item2.inv_amt);
        } else {
          if (item2.inv_amt < 0) {
            total -= parseFloat(item2.display_inv_amt);
          } else {
            total += parseFloat(item2.display_inv_amt);
          }
        }
      });

      this.updated_amt_total = parseFloat(total).toFixed(2);
      this.updated_amt_total =
        parseFloat(this.updated_amt_total) - parseFloat(this.extra_amount);

      // this.updated_amt_total != 0
      //   ? this.updated_amt_total
      //   : this.extra_amount
      //   ? this.extra_amount
      //   : 0;
      this.display_updated_amt_total = this.getAmountFormat(
        this.updated_amt_total
      );
      this.selected_group.total_extra_amount = this.extra_amount;

      let last_match_balance_value = 0;
      if (this.extra_amount) {
        last_match_balance_value =
          parseFloat(this.selected_group.total_group_amount) +
          parseFloat(this.selected_group.previous_amount) +
          parseFloat(this.updated_amt_total);
      } else {
        last_match_balance_value =
          parseFloat(this.selected_group.total_group_amount) +
          parseFloat(this.selected_group.previous_amount) +
          parseFloat(this.updated_amt_total);
      }

      this.last_match_balance_value = parseFloat(
        last_match_balance_value
      ).toFixed(2);
      // if(this.extra_amount){
      // if(this.last_match_balance_value < 0){
      //   this.invoice_btn_flag=true;
      // }else{
      //   this.invoice_btn_flag=false;
      // }
      // }else{
      if (this.last_match_balance_value < 0) {
        this.invoice_btn_flag = true;
      } else {
        this.invoice_btn_flag = false;
      }
      // }
    },
    generateInvoice() {
      this.generate_invoice_loading = true;
      axios
        .post("generate_invoice", {
          items: this.items,
          selected_rows: this.selected_rows,
          project_details: this.project_details,
          is_update_invoice: this.is_update_invoice,
          generate_invoice_id: this.generate_invoice_id
        })
        .then(res => {
          this.setAlert({
            show: true,
            variant: "primary",
            message: res.data.message,
            dismissCountDown: 0
          });
          this.generate_invoice_loading = false;
          this.$emit("successGenerateInvoice");
          this.$emit("closeDialog");
        })
        .catch(() => {
          this.generate_invoice_loading = false;
        });
    },
    updateInvoiceAmt() {
      let total = 0;

      this.selected_rows = this.selected_rows.filter(item => {
        this.trans_items.filter(item2 => {
          if (item2.trans_id == item.trans_id) {
            // item.inv_amt = item2.inv_amt
            // total += parseFloat(item.inv_amt)

            if (item2.display_inv_amt == this.getAmountFormat(item2.inv_amt)) {
              total += parseFloat(item2.inv_amt);
            } else {
              if (item2.inv_amt < 0) {
                total -= parseFloat(item2.display_inv_amt);
              } else {
                total += parseFloat(item2.display_inv_amt);
              }
            }
          }
        });
        return item;
      });

      let id = this.selected_group.invoice_group_id;
      let change_order = this.selected_group.change_order;
      let i = 0;
      this.items = this.items.filter(item => {
        if (item.invoice_group_id == id && item.change_order == change_order) {
          item.current_amount =
            parseFloat(total) - parseFloat(this.extra_amount);
          item.display_current_amount = parseFloat(
            this.getAmountFormat(item.current_amount)
          ).toFixed(2);
          item.is_extra_amount = this.extra_amount ? true : false;
        }

        item.completed_amount = this.getCompletedAmount(item);
        item.display_completed_amount = parseFloat(
          this.getAmountFormat(item.completed_amount)
        ).toFixed(2);
        item.percent_value = this.getPercentAmount(item);
        item.display_percent_value = this.getAmountFormat(item.percent_value);
        item.balance_amount = parseFloat(this.getBalanceAmount(item)).toFixed(
          2
        );
        item.display_balance_amount = this.getAmountFormat(item.balance_amount);
        if (item.balance_amount >= 0 && item.balance_amount <= 0.09) {
          item.balance_amount = parseFloat(0).toFixed(2);
        }

        item.retainage_amount = parseFloat(
          this.getRetainageAmount(item)
        ).toFixed(2);
        item.display_retainage_amount = this.getAmountFormat(
          item.retainage_amount
        );

        if (item.balance_amount < 0) {
          i++;
        }
        return item;
      });

      if (i > 0) {
        this.generate_btn_flag = true;
      } else {
        this.generate_btn_flag = false;
      }
      this.change_tran_amt_dialog = false;
    },
    getCompletedAmount(item) {
      return parseFloat(item.previous_amount) + parseFloat(item.current_amount);
    },
    getPercentAmount(item) {
      if (item.total_group_amount) {
        return Math.round(
          (100 * parseFloat(this.getCompletedAmount(item))) /
            parseFloat(item.total_group_amount)
        );
      } else {
        return 0.0;
      }
    },
    getBalanceAmount(item) {
      return (
        parseFloat(item.total_group_amount) +
        parseFloat(this.getCompletedAmount(item))
      );
    },
    getRetainageAmount(item) {
      if (
        this.project_details.is_retainage == "1" &&
        this.project_details.retainage_percentage != ""
      ) {
        return parseFloat(
          (this.getCompletedAmount(item) *
            this.project_details.retainage_percentage) /
            100
        ).toFixed(2);
      } else {
        return 0.0;
      }
    },
    changeTranAmtDialog(item) {
      this.selected_group = item;
      this.extra_amount = this.selected_group.is_extra_amount
        ? Math.abs(this.selected_group.total_extra_amount).toFixed(2)
        : 0;
      this.updated_current_amount = item.current_amount;

      this.last_match_balance_value =
        Number(parseFloat(item.total_group_amount).toFixed(6)) +
        Number(parseFloat(item.previous_amount).toFixed(6)) +
        Number(parseFloat(item.current_amount).toFixed(6));

      this.trans_items = this.selected_rows.filter(item2 => {
        if (
          item2.invoice_group_id == item.invoice_group_id &&
          item.change_order == item2.change_order
        ) {
          return item;
        }
      });

      this.has_extra_row = this.trans_items.length;
      var total = 0;
      this.trans_items.filter(item3 => {
        total += parseFloat(item3.inv_amt);
        item3.inv_amt = parseFloat(item3.inv_amt).toFixed(2);
      });

      this.updated_amt_total =
        parseFloat(total) - parseFloat(this.extra_amount);
      this.display_updated_amt_total = this.getAmountFormat(
        parseFloat(total) - parseFloat(this.extra_amount)
      );
      if (total > item.total_group_amount) {
        this.invoice_btn_flag = true;
      }
      this.change_tran_amt_dialog = true;
    },
    getInvoiceAmt(item) {
      let total = this.getAmountFormat(item.rev_amount);
      total = getTotalOrderAmountwithAllcalculation(
        item.project.p_price,
        item.project.multiplier,
        item.rev_amount
      );
      return total;
    },
    getAmountFormat(value) {
      if (value) {
        return value.toString().replace("-", "");
      } else {
        return 0;
      }
    },
    getFormatedDate(date) {
      return moment(date).format("MM/DD/YY");
    }
  }
};
</script>
<style>
.error--text input {
  color: #a61f38 !important;
}
.primary--text input {
  color: #6e9a35 !important;
}
</style>